// src/components/manuscripts/manuscriptStyles.js
//
// The `sx` fragments shared by the Manuscripts tab's components.
//
// Its own module, small as it is, because the alternative was a cycle:
// ManuscriptsWorkspace renders ManuscriptSection, so Section importing back
// from Workspace closes a loop. ES modules tolerate that when the value is
// only read inside a render, which is exactly the kind of thing that works
// until someone moves it to the top level.

/**
 * MUI shouts. The prototype does not.
 *
 * `MuiButton` uppercases its label by default, so "Sort by: Last edited" came
 * out as "SORT BY: LAST EDITED" and every control on the tab read louder than
 * the manuscript titles beside it -- which are the thing you are meant to be
 * reading. It was the single most visible difference from the mock, ahead of
 * any colour or radius.
 *
 * Scoped to this tab rather than fixed in `theme.js`, because the rest of the
 * product is built around the caps -- the Library rail, the review queue --
 * and turning them off globally would restyle every screen at once. That is a
 * design decision for the whole app, not a side effect of one ticket.
 */
export const QUIET_BUTTON = { textTransform: 'none' };
